// @flow
import React from "react";
import Streetview from "../../../svg/streetview.svg";
import "./streetviewIcon.scss";

const StreetviewIcon = () => <Streetview className="c-streetview-icon" />;

export default StreetviewIcon;
